module.exports = __webpack_public_path__ + "img/risks-sexual-difficulties.9732b8d8.svg";